module.exports = __webpack_public_path__ + "static/img/ptzs4.254c6a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ptzs4.png
// module id = HK0l
// module chunks = 0